import {twistoCheck} from "p360wsc-js/payments/twisto";
import './lazy-list';
import {taxonList} from "./lazy-list";
import './constants';
import {login} from "./login";

(function() {
    $.fn.extend({
        isInViewport: function(mode = 'both') {
            const $window = $(window);
            const $this = $(this);
            if ($this.length === 0) {
                return false;
            }

            const thisTop = $this.offset().top;
            const thisBottom = thisTop + $this.outerHeight();
            const viewportTop = $window.scrollTop();
            const viewportBottom = viewportTop + $window.height();

            if (mode === 'both') {
                return (viewportTop <= thisTop) && (viewportBottom >= thisBottom);
            } else if (mode === 'top') {
                return viewportTop <= thisTop;
            } else if (mode === 'bottom') {
                return viewportBottom >= thisBottom;
            }
        },
        confirmationListeners: function(onYes, onNo) {
            if (typeof onNo === 'function') {
                $('#confirmation-modal .btn.cancel').bind('click', onNo);
            }
            if (typeof onYes === 'function') {
                $('#confirmation-modal #confirmation-button').bind('click', onYes);
                $('#confirmation-modal .btn.cancel').click(function() {
                    $('#confirmation-modal #confirmation-button').unbind('click', onYes);
                });
            }
        },
        submitViaAjax: function(callback = undefined) {
            let element = this[0];
            if (element.tagName !== 'FORM') {
                throw new Error("Only forms are submittable");
            }
            const promise = $.post(element.action, this.serialize());
            if (callback) {
                promise.then(callback);
            }
        },
        registerValidationErrors: function(validationErrors) {
            validationErrors.each(function() {
                var fullName = $(this).data('field-full-name');
                if (fullName) {
                    let errorMessage = $(this);
                    $('[name^="' + fullName + '"]').on('input change', function() {
                        errorMessage.remove();
                    });
                }
            });
        },
        smoothScrollLeft: function(to, step = 15) {
            if (to < 0) {
                throw new Error('"To" cannot be less than zero');
            }
            var el = this[0];
            var diff = to - el.scrollLeft;
            var absDiff = Math.abs(diff);
            var toRight = diff > 0;
            if (absDiff === 0) {
                return; // no reason to scroll
            }
            step = Math.abs(absDiff > 0 && absDiff < step ? diff : step);
            var previousScrollLeft = el.scrollLeft;
            el.scrollLeft = el.scrollLeft + (toRight ? step : -1 * step);
            if (previousScrollLeft === el.scrollLeft) {
                return; // cannot scroll, returning to prevent infinite recursion
            }
            if (toRight ? el.scrollLeft < to : el.scrollLeft > to) {
                setTimeout(function() {
                    $(el).smoothScrollLeft(to, step);
                }, 20);
            }
        },
        primaryMenu: function() {
            const menu = this[0];
            const activeItemClass = 'nav-item__link--active';

            $(menu).on('set-active-menu-item', function(event, data) {
                $(menu).find('a.nav-item__link').each(function() {
                    if (this === data.item) {
                        // dont chain this condition with the one above - you'll break it
                        if (!$(this).hasClass(activeItemClass)) {
                            $(this).addClass(activeItemClass);
                        }
                    } else if ($(this).hasClass(activeItemClass)) {
                        $(this).removeClass(activeItemClass);
                    }
                });
            });
        },
        carouselMenu: function() {
            const carousel = this[0];

            (function validateDom() {
                if (!$(carousel).find('.carousel-shift.carousel-shift--left').length) {
                    throw new Error('Left button not found');
                }
                if (!$(carousel).find('.carousel-shift.carousel-shift--right').length) {
                    throw new Error('Right button not found');
                }
                if (!$(carousel).find('.carousel-items').length) {
                    throw new Error('Carousel items not found')
                }
            })();

            const carouselItems = $(this).find('.carousel-items')[0];
            const leftButton = $(this).find('.carousel-shift.carousel-shift--left')[0];
            const rightButton = $(this).find('.carousel-shift.carousel-shift--right')[0];
            let activeItemClass = 'current-category';

            function scrollLeft(toItem) {
                $(carouselItems).smoothScrollLeft(toItem.offsetLeft);
            }

            function scrollRight(toItem) {
                let rightEdge = carouselItems.scrollLeft + carouselItems.offsetWidth;
                $(carouselItems).smoothScrollLeft(carouselItems.scrollLeft + Math.abs(((toItem.offsetLeft + toItem.offsetWidth) - rightEdge)));
            }

            function scrollTo(item) {
                if (item.offsetLeft < carouselItems.scrollLeft) {
                    scrollLeft(item);
                }
                if ((item.offsetLeft + item.offsetWidth) > (carouselItems.scrollLeft + carouselItems.offsetWidth)) {
                    scrollRight(item);
                }
            }

            function setActiveItem(item) {
                $(item).addClass('current-category');
                scrollTo(item);
            }

            function clickLeft() {
                let leftEdge = carouselItems.scrollLeft;
                let item = $(carouselItems).children().toArray().slice().reverse().filter(function(item) {
                    return item.offsetLeft < leftEdge || leftEdge > (item.offsetLeft + item.offsetWidth);
                })[0];
                if (item) {
                    scrollLeft(item);
                }
            }

            function clickRight() {
                let rightEdge = carouselItems.scrollLeft + carouselItems.offsetWidth;
                let item = $(carouselItems).children().toArray().slice().filter(function(item) {
                    return item.offsetLeft > rightEdge || rightEdge < (item.offsetLeft + item.offsetWidth);
                })[0];
                if (item) {
                    scrollRight(item);
                }
            }

            leftButton.addEventListener('click', clickLeft);
            rightButton.addEventListener('click', clickRight);

            $(carousel).on('set-active-carousel-item', function(event, data) {
                $(carouselItems).children().each(function() {
                    if (this === data.item) {
                        // dont chain this condition with the one above - you'll break it
                        if (!$(this).hasClass(activeItemClass)) {
                            $(this).addClass(activeItemClass);
                        }
                    } else if ($(this).hasClass(activeItemClass)) {
                        $(this).removeClass(activeItemClass);
                    }
                });
                if (data.scrollIntoView) {
                    scrollTo(data.item);
                }
            });
        },
        coverWithLoader: function() {
            $(this).prepend($('<div class="ui active dimmer"><div class="ui loader"></div></div>'));
        },
        removeLoaders: function() {
            $('.ui.active.dimmer').remove();
        },
        hide2: function() {
            if (!this.hasClass('hidden')) {
                this.addClass('hidden');
            }
        },
        show2: function() {
            if (this.hasClass('hidden')) {
                this.removeClass('hidden');
            }
            let hiddenField = $(this).parents('[hidden="hidden"]');
            if (hiddenField.length) {
                $(hiddenField).first().removeAttr('hidden');
            }
        },
        activateDismissErrorsOnChange: function() {
            $(this).find('[data-dismiss-errors-on-change]').on('change input', function(e) {
                $('[class*="validation-error"][data-field-full-name="' + e.currentTarget.dataset.dismissErrorsOnChange + '"]').each(function() {
                    $(this).remove();
                });
            });
        },
        loginForm: function() {
            login({
                form: $(this).find('form.login-form'),
                usernameInput: $(this).find('input[name="_username"]'),
                proceedButton: $(this).find('.js-login-form-button'),
                backButton: $(this).find('.js-login-back-button'),
                skipButton: $(this).find('.js-login-skip-button'),
                steps: {
                    username: $(this).find('.login-step-username'),
                    password: $(this).find('.login-step-password'),
                    webAuthn: $(this).find('.login-step-webauthn')
                },
            }, {
                webAuthnCheckUrl: $(this).data('webauthn-check-url')
            });
        },
        twistoCheck: twistoCheck,
        taxonList: taxonList,
        isHidden: function() {
            return $(this).css('display') === 'none';
        }
    });
})();